module.exports = __webpack_public_path__ + "aaf8396f10a975f8a393cd8df23d95a6.svg";